import React, { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import BookingConsultation from "./BookingConsultation";
import http from "../../../src/Redux/services/http-common.jsx";
import { TabPanel, TabView } from "primereact/tabview";

function MainDiagnostics() {
  const toast = useRef(null);

  // --- pagination state ---
  const [currentPage, setCurrentPage] = useState(0);      // API pageNumber
  const [rowsPerPage, setRowsPerPage] = useState(10);     // API pageSize
  const [totalRecords, setTotalRecords] = useState(0);    // API totalElements
  const [status,setStatus] =useState(22)
  // --- data/modal state ---
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [consultationModal, setConsultationModal] = useState(false);
  const [sideDialogue, setSideDialog] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
const [selectedTestType, setSelectedTestType] = useState("Pathology");
  const consultationOptions = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" }
  ];

    const statusOptions = [
    { label: 'Consent Pending', value: 22 },
    { label: 'Consultation Pending', value: 23 },
    { label: 'Consultation Completed', value: 24 }
  ];

  // --- fetch page of data ---
  const handleSearchSubmit = (page = 0, size = rowsPerPage) => {
    setLoading(true);
    setNoData(false);

    const url = `${process.env.REACT_APP_DIAGNOSTIC}patientLabTestsOrder/list/filter`
      + `?page=${page}&status=${status}&testType=${selectedTestType}`;

    http.get(url)
      .then((res) => {
        const data    = res.data;
        const content = data?.content || [];
        setSearchResults(content);
        setTotalRecords(data?.totalElements ?? 0);
        setNoData(content.length === 0);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setSearchResults([]);
        setTotalRecords(0);
        setNoData(true);
      })
      .finally(() => setLoading(false));
  };

  // on first mount, load page 0
  useEffect(() => {
    handleSearchSubmit(0, rowsPerPage);
  }, [selectedTestType,status]);

  // when user clicks “Yes/No” on Consent dropdown
  const handleConsultationChange = async (value, rowData) => {
    const orderId = rowData?.orderid;
    if (!orderId) return;

    try {
      await http.put(
        `${process.env.REACT_APP_DIAGNOSTIC}`
        + `patientLabTestsOrder/consultation-consent?orderId=${orderId}&status=${value}`
      );

      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: `Consent updated`,
        life: 2000
      });

      if (value === 'Y') {
        setSelectedPatient(rowData);
        setConsultationModal(true);
        setStatus(23);
      } else {
        // refresh current page
        handleSearchSubmit(currentPage, rowsPerPage);
        setStatus(23);
      }
    } catch (error) {
      console.error("Failed to update consent:", error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to update consultation consent',
        life: 3000
      });
    }
  };

  // “Yes” on the confirmation dialog
  const handleBookConsultation = () => {
    setConsultationModal(false);
    setSideDialog(true);
  };

  // DataTable pagination event
  const onPage = (event) => {
    const newPage = event.page;      // 0-based
    const newRows = event.rows;
    setCurrentPage(newPage);
    setRowsPerPage(newRows);
    handleSearchSubmit(newPage +1, newRows);
  };

  return (
    <div style={{ padding: "20px",backgroundColor:'white' }}>
      <Toast ref={toast} />


   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <TabView
          activeIndex={selectedTestType === "Radiology" ? 1 : 0}
          onTabChange={e => {
            const type = e.index === 0 ? "Pathology" : "Radiology";
            setSelectedTestType(type);
            setCurrentPage(0);
          }}
        >
          <TabPanel header="Pathology" />
          <TabPanel header="Radiology" />
        </TabView>

        <Dropdown
          options={statusOptions}
          value={status}
          onChange={e => {
            setStatus(e.value);
            setCurrentPage(0);
          }}
          placeholder="Status"
          style={{ width: 200 }}
        />
      </div>
            {/* <TabView
              activeIndex={selectedTestType === "Radiology" ? 1 : 0}
              onTabChange={(e) => {
                const type = e.index === 0 ? "Pathology" : "Radiology";
                setSelectedTestType(type);
                setCurrentPage(0);
                handleSearchSubmit(0, rowsPerPage);
              }}
            >
              <TabPanel header="Pathology" />
              <TabPanel header="Radiology" />
            </TabView> */}

            

      {loading ? (
        <div style={{
          textAlign: "center",
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "blue" }} />
        </div>
      ) : noData ? (
        <div style={{
          textAlign: "center",
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          No Data Found
        </div>
      ) : (
        <DataTable
          value={searchResults}
          lazy                               // enable server-side pagination
          paginator
          rows={rowsPerPage}
          first={currentPage * rowsPerPage}
          totalRecords={totalRecords}
          onPage={onPage}
          showGridlines
          stripedRows
          emptyMessage="No records found"
        >
          <Column header="Order ID" field="orderid" />

          <Column
            header="Patient Details"
            body={row => {
              const p = row.patient || {};
              return (
                <div>
                  <div><strong>{`${p.firstName||""} ${p.lastName||""}`.trim()}</strong></div>
                  <div style={{ fontSize:12, color:'#555' }}>{p.email||'-'}</div>
                  <div style={{ fontSize:12, color:'#555' }}>{p.mobile||'-'}</div>
                </div>
              );
            }}
          />

          <Column
            header="Patient Address"
            body={row => {
              const p = row.patient || {};
              const addr = [p.address1, p.address2, p.city, p.state, p.pincode]
                .filter(Boolean).join(', ');
              return <div style={{ fontSize:12, color:'#555' }}>{addr||'-'}</div>;
            }}
          />

          <Column
            header="Lab Name"
            body={row => row.labHospitalDetails?.name || "-"}
          />

          <Column
            header="Collection Center"
            body={row => row.eclinicHospitalDetails?.name || "-"}
          />

          <Column
            header="Consultation Consent"
            body={rowData => {
              const c = rowData.consultationConsent;
              if (c === "Y") return <span style={{color:'green', fontWeight:'bold'}}>Yes</span>;
              if (c === "N") return <span style={{color:'red',   fontWeight:'bold'}}>No</span>;
              return (
                <Dropdown
                  options={consultationOptions}
                  onChange={e => handleConsultationChange(e.value, rowData)}
                  placeholder="Select"
                  style={{ width: 100 }}
                />
              );
            }}
          />

          <Column
           header="Book Consultation"
           body={rowData =>
            ( rowData.consultationConsent === "Y") && rowData?.status === '23' ? (
               <Button
                 label="Consult"
                 icon="pi pi-user-md"
                 onClick={() => {
                   setSelectedPatient(rowData);  
                    setSideDialog(true);
                 }}
                 className="p-button-sm p-button-rounded"
               />
             ) : null
           }
         />
        </DataTable>
      )}

      <Dialog
        visible={sideDialogue}
        onHide={() => {
          setSideDialog(false);
          setSelectedPatient(null);
        }}
        style={{ width: '50vw' }}
        header="Book Consultation"
      >
        {selectedPatient && (
          <BookingConsultation
            selectedPatient={selectedPatient}
            onClose={() => setSideDialog(false)}
            handleSearchSubmit={() => handleSearchSubmit(currentPage, rowsPerPage)}
            setStatus={setStatus}
          />
        )}
      </Dialog>

      <Dialog
        visible={consultationModal}
        header="Book Consultation"
        onHide={() => setConsultationModal(false)}
        style={{ width: '400px' }}
        footer={(
          <div>
            <Button
              label="No"
              icon="pi pi-times"
              onClick={() => setConsultationModal(false)}
              className="p-button-text"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              onClick={handleBookConsultation}
              autoFocus
            />
          </div>
        )}
      >
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <i className="pi pi-question-circle" style={{ fontSize: '3rem', color: '#f39c12' }} />
          <h3>Do you want to book consultation?</h3>
          {selectedPatient && (
            <div style={{ marginTop: '15px', textAlign: 'left' }}>
              <p><strong>Patient:</strong> {selectedPatient.patient?.firstName} {selectedPatient.patient?.lastName}</p>
              <p><strong>Mobile:</strong> {selectedPatient.patient?.mobile}</p>
              <p><strong>Order ID:</strong> {selectedPatient.orderid}</p>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}

export default MainDiagnostics;
